import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

/**
 * Bronson Efficiency Tag component.
 * @see https://bronson.vwfs.tools/default/components/detail/bronson-efficiency-tag.html
 *
 * @param {string} [className] - Additional CSS classes on the component element.
 * @param {string} [label] - Optional custom label. If none is specified the {@link rating} will be used.
 * @param {('a+++'|'a++'|'a+'|'a'|'b'|'c'|'d'|'e'|'f'|'g')} [rating] - A product rating class identifier.
 * @param {string} [testId] - The `[data-testid]` attribute on the component element.
 * @param {object} [otherProps] - Other props passed to the component element.
 * @returns {JSX.Element} - The EfficiencyTag component.
 * @constructor
 */
export function EfficiencyTag({ className, label, rating, testId, ...otherProps }) {
  const classNameList = classNames('c-efficiency-tag', className).trim()
  return (
    <span className={classNameList} data-efficiency-tag={rating} data-testid={testId} {...otherProps}>
      {label ?? rating?.toUpperCase()}
    </span>
  )
}

EfficiencyTag.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string, // Bronson template: 'label'.
  rating: PropTypes.oneOf(['a+++', 'a++', 'a+', 'a', 'b', 'c', 'd', 'e', 'f', 'g']), // Bronson template: 'rating'.
  testId: PropTypes.string, // Added for the `[data-testid]` attribute.
}
